import React, { Fragment } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";


const MCQQuestion = React.memo(({ index, input, onQuestionTextChange, onAddOption, onOptionTextChange, onDeleteOption, onGraceMarkChange, removeHandler }) => {

    return (
        <Fragment>
            <div className="row m-0 mb-2 mt-3">
                <div className="col-12">
                    <label className="fw-bold ">Question No: {index + 1}</label>
                </div>
            </div>
            <div className="row m-0 ">
                <div className="col-12 d-flex  mb-2">
                    <input
                        className="form-control question text-primary custom-input custom-title-color"
                        placeholder="Question"
                        value={input && input.question}
                        onChange={(e) =>
                            onQuestionTextChange(input.id, e.target.value)
                        }
                    />
                    {index > 0 && (
                        <button
                            type="button"
                            title="Remove Question"
                            className="btn btn-sm btn-outline-danger ms-4 my-2 pt-1 pb-0"
                            onClick={() => removeHandler(input.id)}
                        >
                            <i className="pi pi-times"></i>
                        </button>
                    )}
                </div>
            </div>

            {input && input.options.map((opt, i) => (
                <div className="row m-0 pt-2 pb-2" key={i}>
                    <div className="col-12 d-flex ">
                        <div className="p-inputgroup flex-1 custom-input ">
                            <span className="p-inputgroup-addon custom-title-color">
                                <Checkbox
                                    checked={opt.isAnswer}
                                    onChange={(e) =>
                                        onOptionTextChange(input.id, opt.id, opt.option, e.target.checked)
                                    }
                                />
                            </span>
                            <InputText className="custom-input-color"
                                placeholder={`Option ${i + 1}`}
                                value={opt.option}
                                onChange={(e) =>
                                    onOptionTextChange(input.id, opt.id, e.target.value, opt.isAnswer)
                                }
                            />
                            {input && input.options.length > 2 && (
                                <button
                                    type="button"
                                    title="Remove Option"
                                    className="btn btn-sm btn-outline-danger my-2  ms-4  pt-1 pb-0"
                                    onClick={() => onDeleteOption(input.id, opt.id)}
                                >
                                    <i className="pi pi-times"></i>
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            ))}
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-2 mt-2 px-2 mx-1">
                <div className="" style={{ minWidth: "200px" }}>
                    <div
                        className="p-inputgroup custom-title-color py-2"
                        style={{
                            display: "flex",
                            alignItems: "center",

                            borderRadius: "0.375rem",
                            overflow: "hidden",
                            height: "38px",
                            width: "200px",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "0 0.75rem",
                            }}
                        >
                            <Checkbox
                                inputId={`graceMark-${index}`}
                                checked={input?.hasGraceMark}
                                onChange={(e) => onGraceMarkChange(input.id, e.target.checked)}
                            />
                        </div>
                        <label
                            htmlFor={`graceMark-${index}`}
                            className="mb-0"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                flex: 1,
                                whiteSpace: "nowrap",
                            }}
                        >
                            Has Grace Mark?
                        </label>
                    </div>
                </div>
                <button

                    label="Add Option"
                    icon="pi pi-plus"
                    className="py-2 btn btn-outline"
                    title={input && input.options.length >= 5 ? 'Only 5 options can be added' : 'Add Option'}
                    disabled={input && input.options.length >= 5}
                    onClick={() => onAddOption(input.id)}
                >Add Option</button>
            </div>
            <hr className="mx-2" />
        </Fragment>
    );
});

export default MCQQuestion;